module.exports = __webpack_public_path__ + "static/media/05.f020c7ed.jpg";